"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOutputStatusLabel;

var _statusMap = _interopRequireDefault(require("../constants/statusMap"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getOutputStatusLabel(status) {
  return _statusMap.default[status] || status.split('_').map(function (word) {
    return "".concat(word[0]).concat(word.slice(1, word.length).toLowerCase());
  }).join(' ');
}